import { render, staticRenderFns } from "./DeviceInventoryList.vue?vue&type=template&id=5e8c8af1&scoped=true"
import script from "./DeviceInventoryList.vue?vue&type=script&lang=js"
export * from "./DeviceInventoryList.vue?vue&type=script&lang=js"
import style0 from "./DeviceInventoryList.vue?vue&type=style&index=0&id=5e8c8af1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8c8af1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e8c8af1')) {
      api.createRecord('5e8c8af1', component.options)
    } else {
      api.reload('5e8c8af1', component.options)
    }
    module.hot.accept("./DeviceInventoryList.vue?vue&type=template&id=5e8c8af1&scoped=true", function () {
      api.rerender('5e8c8af1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectOverview/DeviceInventoryList.vue"
export default component.exports